import { SliderDropdown as SliderDropdownType } from '../../../../../../types/Survey/Element'
import { SliderDropdown as SliderDropdownAnswerType } from '../../../../../../types/Survey/Analysis/Element'
import { Props } from './types'
import Core from './Core'
import Pie, { Item as PieItem } from '../../../../../UI/Chart/Pie/Pie'
import { blue, gray } from '../../../../../UI/Chart/colors'
import { ChartType } from './ChartSelector'
import { useState } from 'react'
import BarCluster, { Item as BarClusterItem } from '../../../../../UI/Chart/BarCluster/BarCluster'
import { useSelector } from 'react-redux'
import props from '../../../../../../redux/props'
import { round } from 'lodash'

const SliderDropdown: React.FC<Props<SliderDropdownType, SliderDropdownAnswerType> & { small?: boolean }> = ({
  element,
  analysisElement,
  small = false,
}) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const [activeChart, setActiveChart] = useState(ChartType.PIE)

  const getPieChartItems = (): PieItem[] => {
    return [
      {
        label: `${element.title}`,
        value: round(analysisElement.value.average),
        ...blue,
      },
      {
        label: `${element.counterWeightText || ''}`,
        value: 100 - round(analysisElement.value.average),
        ...gray,
      },
    ]
  }

  const getBarClusterChartItems = (): BarClusterItem[] => {
    return [
      round(analysisElement.sliderCluster.range0To25.percentage),
      round(analysisElement.sliderCluster.range26To50.percentage),
      round(analysisElement.sliderCluster.range51To75.percentage),
      round(analysisElement.sliderCluster.range76To100.percentage),
    ]
  }

  const getOptions = () => {
    return element.dropdownOptions.map((option) => ({
      title: option.value,
      value: round(analysisElement.optionCluster[option.uuid].percentage),
    }))
  }

  return (
    <div className="w-full">
      <Core
        element={element}
        availableChartOptions={[ChartType.PIE, ChartType.BAR_CLUSTER]}
        activeChart={activeChart}
        setActiveChart={setActiveChart}
        small={small}
      />
      <div className={`flex justify-center ${small ? 'mt-3' : 'mt-5'}`}>
        {activeChart === ChartType.PIE && (
          <div className="w-full">
            <Pie items={getPieChartItems()} enableDownload />
          </div>
        )}
        {activeChart === ChartType.BAR_CLUSTER && <BarCluster enableDownload items={getBarClusterChartItems()} />}
      </div>
      <div className="flex flex-col mt-5">
        {getOptions().map((o) => (
          <div className="flex justify-between">
            <div className="text-sm">{o.title}</div>
            <div className="text-sm">
              {round(o.value)}
              {t.generic.percentageSuffix}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default SliderDropdown
